import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-copy-right',
  templateUrl: './footer-copy-right.component.html',
  styleUrls: ['./footer-copy-right.component.scss'],
})
export class FooterCopyRightComponent implements OnInit {
  @Input() sizeClass: string | undefined;
  copyRights: string | undefined;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate.get('COPY_RIGHT_ALL_RESERVED').subscribe((translation: string) => {
      this.copyRights = translation;
    });
  }
}
